import dayjs from "dayjs";
import { airportLocalToUtc } from "../../utils/airportTz";

export function getAirlineFromEntry(parts) {
  return parts[0].split(" ")[0];
}

export function getFlightNoFromEntry(parts) {
  return parts[0].split(" ")[1];
}

// Interpret schedule-flight time strings ("01 Jul 05:15") as local time IN
// THE AIRPORT'S OWN TIMEZONE. Airlines publish schedule times in the
// airport's local time — ONT flights are Pacific, MEM flights are Central,
// FLL flights are Eastern, etc. Storing them all as ET (the previous
// behavior) was correct for ET airports but shifted Pacific/Central
// airports by hours. See utils/airportTz.js for the airport→TZ map.
const MONTHS = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                 Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };

// Convenience wrapper so callers with no airport context (e.g. legacy
// paths, TripAdd) keep the previous ET default without needing to import
// the new helper.
export function easternLocalToUtc(y, m, d, hh, mi) {
  return airportLocalToUtc(null, y, m, d, hh, mi);
}

const TIME_RE = /^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{1,2}):(\d{2})$/;

export function getDropoffTimeFromEntry(parts, year, airportCode) {
  const timeString = (parts[1] || "").trim();
  const m = timeString.match(TIME_RE);
  if (m) {
    const mon = m[2][0].toUpperCase() + m[2].slice(1, 3).toLowerCase();
    const monthIdx = MONTHS[mon];
    if (monthIdx != null) {
      return airportLocalToUtc(
        airportCode,
        year,
        monthIdx,
        parseInt(m[1], 10),
        parseInt(m[3], 10),
        parseInt(m[4], 10)
      );
    }
  }
  // Malformed cell — return null so the importer treats the row as invalid
  // instead of silently constructing a browser-local Date (which would
  // re-introduce the same offset bug that hit August imports).
  console.warn("getDropoffTimeFromEntry: could not parse", timeString);
  return null;
}

export function endsWithTime(str) {
  const timeRegex = /(?:^|\s)([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return timeRegex.test(str);
}

export const passValidation = ({ scheduleDate, airport, pickup, dropoff }) => {
  return (
    !!scheduleDate &&
    !!airport &&
    !!airport.trim() &&
    !!pickup &&
    !!dropoff &&
    !!dropoff.trim()
  );
};
